var TaxB2PModule = (function () {
    function TaxB2PModule() {
    }
    return TaxB2PModule;
}());
export { TaxB2PModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-b2p/tax-b2p.module.ts.pre-build-optimizer.js